import { reactive } from 'vue'

/** Primeiros segmentos que não são master_code do tenant na vitrine pública */
export const RESERVED_FIRST_SEGMENTS = new Set([
  'admin',
  'api',
  'rails',
  'public',
  'up',
  'property',
  'about',
  'vite-dev',
  'vite-test'
])

export const router = reactive({
  currentRoute: 'dashboard',
  params: {}
})

function pathnameNormalized() {
  const p = window.location.pathname.replace(/\/+$/, '')
  return p === '' ? '/' : p
}

/**
 * Base da vitrine para montar URLs (/, /tenant ou /tenant após sair de /property/id ou /about).
 */
export function getVitrineBasePath() {
  let p = pathnameNormalized()
  if (p === '/') return '/'
  p = p.replace(/\/property\/\d+$/, '')
  p = p.replace(/\/about$/, '')
  if (p === '') return '/'
  return p
}

/**
 * Sincroniza router reativo com pathname atual (carga inicial e botão voltar).
 */
export function applyLocationToRouter() {
  const path = pathnameNormalized()

  const guestReg = path.match(/^\/public\/guest-person-register\/([^/]+)\/?$/i)
  if (guestReg) {
    router.currentRoute = 'guest-person-register'
    router.params = { token: guestReg[1] }
    return
  }

  const contractSignReg = path.match(/^\/public\/contract-sign\/([^/]+)\/?$/i)
  if (contractSignReg) {
    router.currentRoute = 'contract-sign'
    router.params = { token: contractSignReg[1] }
    return
  }

  const ownerDrawReg = path.match(/^\/public\/owner-contract-draw\/([^/]+)\/?$/i)
  if (ownerDrawReg) {
    router.currentRoute = 'owner-contract-draw'
    router.params = { token: ownerDrawReg[1] }
    return
  }

  if (path === '/admin') {
    router.currentRoute = 'admin'
    router.params = {}
    return
  }

  let m = path.match(/^\/property\/(\d+)\/?$/)
  if (m) {
    router.currentRoute = 'property-detail'
    router.params = { id: m[1] }
    return
  }

  m = path.match(/^\/([a-zA-Z0-9_-]+)\/property\/(\d+)\/?$/)
  if (m && !RESERVED_FIRST_SEGMENTS.has(m[1].toLowerCase())) {
    router.currentRoute = 'property-detail'
    router.params = { id: m[2] }
    return
  }

  if (path === '/about') {
    router.currentRoute = 'about'
    router.params = {}
    return
  }

  m = path.match(/^\/([a-zA-Z0-9_-]+)\/about\/?$/)
  if (m && !RESERVED_FIRST_SEGMENTS.has(m[1].toLowerCase())) {
    router.currentRoute = 'about'
    router.params = {}
    return
  }

  router.currentRoute = 'dashboard'
  router.params = {}
}

export function navigateTo(route, params = {}) {
  router.currentRoute = route
  router.params = { ...params }

  if (route === 'admin') {
    window.history.pushState({}, '', '/admin')
    return
  }

  if (route === 'dashboard') {
    const base = getVitrineBasePath()
    window.history.pushState({}, '', base === '/' ? '/' : base)
    return
  }

  if (route === 'property-detail' && params.id != null) {
    const base = getVitrineBasePath()
    const id = String(params.id)
    const url = base === '/' ? `/property/${id}` : `${base}/property/${id}`
    window.history.pushState({}, '', url)
    return
  }

  if (route === 'about') {
    const base = getVitrineBasePath()
    const url = base === '/' ? '/about' : `${base}/about`
    window.history.pushState({}, '', url)
    return
  }

  // Rotas internas logadas (bookings, people, …): não altera a URL
}

export function goBack() {
  navigateTo('dashboard', {})
}

export function getCurrentRoute() {
  return router.currentRoute
}

export function getParams() {
  return router.params
}
